module.exports = __webpack_public_path__ + "c930b5c5b4f78d390bd261ff762ce9fd.png";